import { useMemo } from 'react';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import useMembers from '@/hooks/useMembers';
import { cn } from '@/lib/utils';

export const NameAvatar = ({
  id,
  name,
  className,
}: {
  id: string;
  name?: string;
  className?: string;
}) => {
  const { members } = useMembers();

  // user can also be a brain, that is why we do not use `member` directly
  const user = useMemo(() => members?.find((member) => member.user_id === id), [members, id]);

  const label = name || user?.name;

  return (
    <div className="flex shrink-0 items-center gap-1">
      <Avatar size="xxs">
        <AvatarImage src={user?.avatar} alt="" />
        <AvatarFallback size="xxs">{label?.[0] || '?'}</AvatarFallback>
      </Avatar>
      <span
        className={cn(
          'text-sm leading-5 font-semibold whitespace-nowrap text-muted-foreground',
          className
        )}
      >
        {label}
      </span>
    </div>
  );
};
